import React, {
  FunctionComponent,
  useState,
  useContext,
  useEffect
} from 'react';
import { ButtonLoader } from '../button-loader/button-loader';
import { Button } from '../button/button';
import styles from './employee-collection.module.scss';
import { IEmployeeBoxProps } from '../employee-box/employee-box';
import { SquareEmployeeBox } from '../square-employee-box/square-employee-box';
import { ITextProps, Text } from '../text/text';
import { AppDeviceSize } from '../../enums/app-device-size';
import { AppStore } from '../../store/app.context';

export interface IEmployeeCollectionProps {
  employeeCollection: IEmployeeBoxProps[];
  contactText: ITextProps[];
  contactBtnText: string;
  showMoreText: string;
  contactMail: string;
}

export const EmployeeCollection: FunctionComponent<IEmployeeCollectionProps> = ({
  employeeCollection,
  contactBtnText,
  contactText,
  showMoreText,
  contactMail
}) => {
  const { state } = useContext(AppStore);
  const { showActiveDevice } = state;
  const [elemsToShow, setElemsToShow] = useState(11);
  const [listLength, setListCount] = useState(11);
  const employeeList = employeeCollection
    .filter(employee => employee.photoUrl)
    .slice(0, listLength);

  useEffect(() => {
    if (showActiveDevice > AppDeviceSize.REGULARDESKTOP) {
      setElemsToShow(15);
      setListCount(15);
    } else {
      setElemsToShow(11);
      setListCount(11);
    }
  }, [showActiveDevice]);

  const onButtonClick = (): void => {
    setListCount(listLength + (elemsToShow + 1));
  };

  return (
    <React.Fragment>
      <div className={styles.wrapper}>
        {employeeList.map(
          (employee, n) =>
            employee && <SquareEmployeeBox key={n} {...employee} />
        )}
        <div className={styles.contactBox}>
          {contactText &&
            contactText.map((text, i) => (
              <Text className={styles.contactText} {...text} key={i} />
            ))}
          <a className={styles.contactLink} href={`mailto:${contactMail}`}>
            <Button
              border="rectangular"
              CTA={true}
              size="large"
              text={contactBtnText}
              className={styles.button}
              transofrmUppercase={true}
            />
          </a>
        </div>
      </div>
      {listLength < employeeCollection.length && (
        <div className={styles.buttonLoader}>
          <ButtonLoader buttonText={showMoreText} onClick={onButtonClick} />
        </div>
      )}
    </React.Fragment>
  );
};
